import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Download, Clock, Lock } from 'lucide-react';
export function CtaSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-charcoal-dark to-charcoal relative" data-id="element-53">
      <div className="max-w-3xl mx-auto" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-warmBrown border border-gold/30 rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden shadow-[0_0_50px_rgba(212,168,83,0.15)]" data-id="element-55">
          {/* Decorative glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-gold/20 blur-[60px] pointer-events-none" data-id="element-56" />

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-900/30 border border-red-500/30 text-red-400 text-sm font-medium tracking-wide mb-8" data-id="element-57">
            <Zap className="w-4 h-4" data-id="element-58" />
            Precio de lanzamiento por tiempo limitado
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/jdVrssbjQjGtppE5kJgSN1/ChatGPT_Image_4_abr_2026,_11_07_59_p.m..png" alt="Pack completo: Ebook en tablet con los 4 bonus" className="max-w-full sm:max-w-lg mx-auto mb-8 drop-shadow-[0_20px_30px_rgba(0,0,0,0.5)]" data-id="element-59" />

          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-60">
            Emprendé con Focaccias
          </h2>
          <p className="text-cream-muted mb-8" data-id="element-61">
            El sistema completo + Todos los bonus exclusivos
          </p>

          <div className="flex flex-col items-center justify-center mb-6" data-id="element-62">
            <span className="text-lg text-cream-muted/60 line-through mb-1" data-id="element-63">
              Precio normal: $29.980 ARS
            </span>
            <div className="flex items-start gap-2 text-gold" data-id="element-64">
              <span className="text-3xl font-bold mt-2" data-id="element-65">$</span>
              <span className="text-6xl sm:text-7xl font-bold tracking-tighter" data-id="element-66">
                14.990
              </span>
              <span className="text-xl font-medium mt-auto mb-2" data-id="element-67">ARS</span>
            </div>
          </div>

          <p className="text-lg text-cream-muted italic mb-10 max-w-md mx-auto" data-id="element-68">
            "Menos de lo que gastás en una salida… pero con potencial de
            generarte ingresos todos los meses"
          </p>

          <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto min-w-[300px] group relative inline-flex items-center justify-center gap-3 px-8 py-5 text-xl font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_40px_rgba(212,168,83,0.4)] hover:shadow-[0_0_60px_rgba(212,168,83,0.6)] mb-6" data-id="element-69">
            <span className="relative z-10" data-id="element-70">QUIERO EMPEZAR HOY &rarr;</span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-71" />
          </motion.a>

          {/* Payment Methods Block */}
          <div className="flex flex-col items-center gap-4 mb-8" data-id="element-72">
            <div className="flex flex-wrap justify-center items-center gap-3" data-id="element-73">
              <span className="bg-[#009EE3] text-white px-3 py-1.5 rounded text-xs font-bold tracking-wide" data-id="element-74">
                mercado pago
              </span>
              <span className="bg-green-600 text-white px-3 py-1.5 rounded text-xs font-bold tracking-wide" data-id="element-75">
                3 cuotas sin interés
              </span>
              <span className="bg-blue-900 text-white px-3 py-1.5 rounded text-xs font-bold italic" data-id="element-76">
                VISA
              </span>
              <span className="bg-red-600 text-white px-3 py-1.5 rounded text-xs font-bold italic" data-id="element-77">
                mastercard
              </span>
            </div>
            <div className="flex items-center gap-2 text-sm text-cream-muted bg-charcoal/50 px-4 py-2 rounded-full border border-white/5" data-id="element-78">
              <Lock className="w-4 h-4 text-gold" data-id="element-79" />
              <span data-id="element-80">Pago 100% seguro y acreditación inmediata</span>
            </div>
          </div>

          <div className="grid sm:grid-cols-3 gap-4 text-sm text-cream-muted/80 max-w-xl mx-auto border-t border-white/10 pt-8" data-id="element-81">
            <div className="flex flex-col items-center gap-2" data-id="element-82">
              <Download className="w-5 h-5 text-gold/70" data-id="element-83" />
              <span data-id="element-84">Acceso inmediato</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-85">
              <ShieldCheck className="w-5 h-5 text-gold/70" data-id="element-86" />
              <span data-id="element-87">Pago seguro</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-88">
              <Clock className="w-5 h-5 text-gold/70" data-id="element-89" />
              <span data-id="element-90">Acceso de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}